var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,4 L16.5,4 C17.33,4 18,4.67 18,5.5 L18,6 L6,6 L6,5.5 C6,4.67 6.67,4 7.5,4 L9,4 L9,3 C9,2.45 9.45,2 10,2 L14,2 C14.55,2 15,2.45 15,3 L15,4 Z M18,7 L18,19.5 C18,20.33 17.33,21 16.5,21 L7.5,21 C6.67,21 6,20.33 6,19.5 L6,7 L18,7 Z M10,10 C10,10.55 9.55,11 9,11 C8.45,11 8,10.55 8,10 C8,9.45 8.45,9 9,9 C9.55,9 10,9.45 10,10 Z M10,14 C10,14.55 9.55,15 9,15 C8.45,15 8,14.55 8,14 C8,13.45 8.45,13 9,13 C9.55,13 10,13.45 10,14 Z M10,18 C10,18.55 9.55,19 9,19 C8.45,19 8,18.55 8,18 C8,17.45 8.45,17 9,17 C9.55,17 10,17.45 10,18 Z M16,10 C16,10.55 15.55,11 15,11 L12,11 C11.45,11 11,10.55 11,10 C11,9.45 11.45,9 12,9 L15,9 C15.55,9 16,9.45 16,10 Z M16,14 C16,14.55 15.55,15 15,15 L12,15 C11.45,15 11,14.55 11,14 C11,13.45 11.45,13 12,13 L15,13 C15.55,13 16,13.45 16,14 Z M16,18 C16,18.55 15.55,19 15,19 L12,19 C11.45,19 11,18.55 11,18 C11,17.45 11.45,17 12,17 L15,17 C15.55,17 16,17.45 16,18 Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.7d458a52657268c671ea2262f99d6571.svg";
export { ForwardRef as ReactComponent };